import { createSelector } from 'reselect';

import { DASHBOARD_PROFILE_ID } from '../../../../routes/const';
import { getFilterCountries } from '../../../../utils/globalSelectors';
import { setDefaultSource } from '../../../../utils/helpers/costcenter';

const getBookmarksCostCenterSelector = state => state.common.costcenter;
const getBookmarksCountrySelector = state => state.common.country;
const getCCAndCountryProps = (costcenter, country, countries) =>
  setDefaultSource(country, costcenter, countries);

const getBookmarksCCAndCountry = createSelector(
  getBookmarksCostCenterSelector,
  getBookmarksCountrySelector,
  getFilterCountries,
  getCCAndCountryProps
);

const getDefaultBookMarksSelector = state => state.bookmarks.bookMarksdata;
export const bookMarksFetchingSelector = state =>
  state.bookmarks.fetchingBookmarks;

export const commonSelector = state => state.common;

const getTransformedState = (bookmarks, source) => {
  // Do all the tranformations and calculations here
  const transformedData = [];

  const driversData = {
    name: 'Drivers',
    key: 'Drivers',
    count: bookmarks && bookmarks.driver ? bookmarks.driver.Total : 0,
    data: []
  };

  const vehiclesData = {
    name: 'Vehicles',
    key: 'Vehicles',
    count: bookmarks && bookmarks.vehicle ? bookmarks.vehicle.Total : 0,
    data: []
  };

  if (bookmarks && bookmarks.driver && bookmarks.driver.Details) {
    for (const obj of bookmarks.driver.Details) {
      const countryCode = obj.CountryCode || source.country.value;
      const route = DASHBOARD_PROFILE_ID.replace(':dashtype', 'driver')
        .replace(':countryCode', countryCode)
        .replace(':refid', obj.DriverId);

      const newObj = {
        DriverID: obj.DriverId,
        DriverFirstName: obj.DriverFirstName,
        DriverLastName: obj.DriverSurname,
        DriverTitleMessage: obj.DaysToolText,
        '@DisplayType': 'driver-card',
        bookmarked: obj.Marked,
        key: obj.DriverId,
        bottom: 25,
        route
      };

      driversData.data.push(newObj);
    }
  }

  if (bookmarks && bookmarks.vehicle && bookmarks.vehicle.Details) {
    for (const obj of bookmarks.vehicle.Details) {
      const countryCode = obj.CountryCode || source.country.value;
      const route = DASHBOARD_PROFILE_ID.replace(':dashtype', 'vehicle')
        .replace(':countryCode', countryCode)
        .replace(':refid', obj.LeaseId);

      const newObj = {
        '@DisplayType': 'card',
        sidePadding: 30,
        Children: [
          {
            '@DisplayType': 'vehicle-card',
            headingVariant: 'secondary',
            bookmarked: obj.Marked,
            horizontal: true,
            horizontalImgWidthPercentage: 40,
            route,
            ...obj
          }
        ]
      };

      vehiclesData.data.push(newObj);
    }
  }

  transformedData.push(driversData, vehiclesData);

  return transformedData;
};

export const driverBookmarksSelector = createSelector(
  getDefaultBookMarksSelector, // pick off a piece of state
  getBookmarksCCAndCountry, // Get the cost center and country source
  getTransformedState // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);



// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/selectors/index.js